exports.api = {
    register: `register`,
    categoryList: `category/list`,
    stateList: `state/list`,
    cityList: `cities/list`,
    registerSendOtp: `send-otp`,
    otpVerify: `verify-otp`,
    notification: `notification/list`,
    unseenNotification: `notification/unseen-count`,
    clearNotification: `notification/clear`,
    seenNotification: `notification/seen/`,
    dashboard: `provider/home`,
    userChatList: `provider/chat/user-list`,
    userBookingList: `provider/booking/list`,
    userProfileDetail: `user/detail/`,
    newsletterSubscribe: `newsletter/subscribe`,
    newsletterUnsubscribe: `newsletter/un-subscribe`,
    addNewsletter: `newsletter/add`,
    planList: `admin/plan`,
    profile: `user/profile`,
    deleteAccount: `delete`,
    updateProfile: `provider/update/`,
    updateProfileImage: `user/profile-image`,
    advertisement: `advertisement/list`,
    deleteAdvertisement: `advertisement/delete/`,
    updateAdvertisement: `advertisement/update/`,
    addAdvertisement: `advertisement/add`,
    postedAdvertisement: `advertisement/my-posted-ads`,
    advertisementDetail: `advertisement/details/`,
    advertisementChangeStatus: `admin/advertisement/status/`,
    tagsList: `tag/list`,
    myJobs: `provider/request/myjob`,
    lockedJobs: `provider/job/requested-list`,
    jobDetails: `admin/care/job-detail/`,
    paymentUnlockRequest: `payment/unlock-request`,
    careNetwork: `job/list`,
    careNetworkDetail: `provider/posted/job/detail/`,
    transactionList: `transaction/history`,
    calendarData: `provider/calenders`,
    applyJob: `job/apply`,
    appliedJob: `job/applied-list`,
    networkDirectory: `provider/List`,
    userDetail: `provider/detail/`,
    providerDealStatus: `provider/deal/status/`,
    sendContactUs: `contactus`,
    contactUsDetail: `contactus`,
    chatImage: `chat/image`,
    reviewList: `reviews/list`,

    expenseDashboard: `expense/dashboard`,
    expenseListing: `expense/list`,
    addBudget: `budget/add`,
    expenseDelete: `expense/delete/`,
    addExpense: `expense/add`,
    editExpense: `expense/update/`,
    detailsExpense: `expense/detail/`,
    categoryListing: `expense/category/list`,
    addCategory: `expense/category/add`,
    cardListing: `expense/card`,
    addCard: `expense/card`,
    budgetList: `budget/list`,
    budgetDelete: `budget/delete/`,
    budgetUpdate: `budget/update/`,

    communityDashboard: `community/dashboard`,
    communitySuggested: `community/list`,
    communityFollow: `community/follow/`,
    communityUnFollow: `community/unfollow/`,
    communityFollowing: `community/my-following`,
    communityList: `community/my-created`,
    communityAdd: `community/add`,
    communityUpdate: `community/update/`,
    communityDelete: `community/delete/`,
    communityDetail: `community/details/`,
    postAdd: `community/post`,
    postUpdate: `community/post/update/`,
    pollAnswer: `community/poll/user/response`,
    postReaction: `post/reaction`,
    communityPostDetail: `community/post/detail/`,
    postComment: `post/comment/add`,
    communityPostDelete: `community/post/delete/`,
    communityCommentDelete: `post/comment/delete/`,
    commentUpdate: `post/comment/update/`,
    commentReaction: `post/comment/reaction`,
    shareProfile: `community/shared/profile`,
    shareCommunityList: `user/community/list`,

    loyaltyCouponList: `coupon/list`,
    couponValidity: `plan/coupon-validity`,
    applyCoupon: `coupon/apply-coupon`,
    leadCouponApply: `loyalty/coupon/apply`,
    leadCouponList: `loyalty/coupon/list`,
    cancelCoupon: `loyalty/coupon/cancel`,
}